import { Injectable } from "@angular/core";
// SignalR ***
import { HubConnection } from '@microsoft/signalr';
import { NgZone } from '@angular/core';
// SignalR ***

@Injectable({
    providedIn: "root",
})
export class SignalRService {
    userId: number;
    constructor(public _zone: NgZone) {}

    events: string[] = [
        "SignalRRefreshAppsAndWebsite",
        "SignalRRefreshRealTimeTracking",
        "SignalRShowLiveScreenshot",
        "SignalRRefreshScreenshot",
        "SignalRRefreshClient",
        "SignalRRefreshTimeTracking",
        "SignalRAgentUserStatus",
        "SignalRUserWiseTaskCreate",
        "SignalRMarkTaskAsCompleted",
        "SignalRRefreshImportData",
        "SignalRUserWiseTaskImportedFromExcel",
        "SignalRUserWiseUserImportedFromExcel",
        "SignalRUserwiseLiveScreenShotData",
        "SignalRRefreshLiveStreaming",
        "SignalRreportAllert",
        "TimesheetOverAllSummaryReport",
        "ProductivityBarReport",
        "LeaveReport",
        "SignalDateWiseNewRreportAllert",
        "SignalROutlookTaskUpdate",
        "UpdateProcess",
        "SignalRRefreshLiveStreamingScreenShot",
        "BulkUpdateManualTime",
        "SignalRallocationReport"

    ];

    // SignalR ***
    SignalRHub: HubConnection;
    isSignalRConnected = false;

    configureSignalRConnection(SignalRConnection): void {
        // Set the common hub
        this.SignalRHub = SignalRConnection;
        // Reconnect loop
        let reconnectTime = 5000;
        let tries = 1;
        let maxTries = 8;
        function start() {
            return new Promise(function (resolve, reject) {
                if (tries > maxTries) {
                    reject();
                } else {
                    SignalRConnection.start()
                        .then(resolve)
                        .then(() => {
                            reconnectTime = 5000;
                            tries = 1;
                        })
                        .catch(() => {
                            setTimeout(() => {
                                start().then(resolve);
                            }, reconnectTime);
                            reconnectTime *= 2;
                            tries += 1;
                        });
                }
            });
        }

        // Reconnect if hub disconnects
        SignalRConnection.onclose((e) => {
            this.isSignalRConnected = false;

            if (e) {
                abp.log.debug("ITP SignalR connection closed with error: " + e);
            } else {
                abp.log.debug("ITP SignalR disconnected");
            }

            start().then(() => {
                this.isSignalRConnected = true;
                this.sendMessage('RegisterClientId', {userId:this.userId,tenantId:abp.session.tenantId,device:"F"});
            });
        });

        //  
        // Register to get notifications
        this.registerSignalREvents(SignalRConnection);
    }

    // registerSignalREvents(SignalRConnection, objthis, eventName: string): void {
    //     SignalRConnection.on(eventName, (objValues) => {
    //         if (objValues) {
    //             objthis.createcallBackFunctionsforSignalR(objValues);
    //         }
    //     });
    // }

    async sendMessage(methodName: string, data: any, callback?: Function): Promise<void> {
        if (!this.isSignalRConnected) {
            if (callback) {
                callback();
            }
            abp.notify.warn("Signal R is not connected");
            return;
        }
        try {
            const result = await this.SignalRHub.invoke(methodName, data)
            if (result) {
                abp.notify.warn(result);
            }
        } catch (ex) {
            abp.log.error(ex);

            if (callback) {
                callback();
            }
        }

        if (callback) {
            callback();
        }
    }

    registerSignalREvents(signalRConnection): void {
        for (let i = 0; i < this.events.length; i++) {
            const eventName = this.events[i];
            signalRConnection.on(eventName, (data) => {
                abp.event.trigger(eventName, data);
            });
        }
    }

    initSignalRConnection(objthis, eventName: string) {
        if (abp.signalr === undefined) return;
        this._zone.runOutsideAngular(() => {
            abp.signalr.connect();
            abp.signalr
                .startConnection(abp.appPath + "notify", (SignalRConnection) => {
                    this.configureSignalRConnection(SignalRConnection);
                })
                .then(() => {
                    abp.event.trigger("SignalRRefresh");
                    this.isSignalRConnected = true;
                    this.sendMessage('RegisterClientId', {userId:this.userId,tenantId:abp.session.tenantId,device:"F"});
                    //console.log('ITP SignalR ******************** Connected');
                });
        });
    }

    init(userId: number): void {
        this.userId = userId;
        this._zone.runOutsideAngular(() => {
            abp.signalr.connect();
            abp.signalr
                .startConnection(abp.appPath + "notify", (connection) => {
                    this.configureSignalRConnection(connection);
                })
                .then(() => {
                    abp.event.trigger("SignalRRefresh");
                    this.isSignalRConnected = true;
                 //  let data = new ;
                 this.sendMessage('RegisterClientId', {userId:this.userId,tenantId:abp.session.tenantId,device:"F"});
                })
        });
    }

    // SignalR ***
}
